import Link from './Link';
import ScrollTop from './ScrollTop';

const Navigation = {
    Link,
    ScrollTop
};

export default Navigation;